import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-owner-medical-consultation-cirugy-table',
  templateUrl: './owner-medical-consultation-cirugy-table.component.html',
  styleUrls: ['./owner-medical-consultation-cirugy-table.component.css']
})
export class OwnerMedicalConsultationCirugyTableComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
